import { SocketClient } from "cbcore-ts"
import { CALL, IF, UIColor, UIRoute, UITextView, UIView, UIViewController, YES } from "uicore-ts"
import { CellView } from "./Custom components/CellView"
import { RHUserProfile, RHCompany } from "./SocketClientFunctions"
import { RHDataView } from "./Custom components/RH/RHDataView"


export class AdministrationViewController extends UIViewController {
    
    readonly titleLabel: UITextView = new UITextView(
        this.view.elementID + "TitleLabel",
        UITextView.type.header2
    ).configuredWithObject({
        text: "Administration"
    }).addedAsSubviewToView(this.view)
    
    explanationView: UITextView = new UITextView().addedAsSubviewToView(this.view).configuredWithObject({
        text: "Siin on administraatori tööpaneel"
    })
    
    dataView = new RHDataView<({ user: RHUserProfile } & { company: RHCompany })>()
        .configuredWithObject({
            // isSearchAvailable: NO,
            // isTreeView: YES
            setBorder: CALL(0, 1),
            descriptors: [
                
                {
                    title: "Type",
                    keyPath: "",
                    // Detect if it is a company or user
                    updateCell: (cellView: CellView, dataItem: ({ user: RHUserProfile } & { company: RHCompany })) =>
                        cellView.titleLabel.text = IF((dataItem as any).company)(() =>
                            "Company"
                        ).ELSE(() =>
                            "User"
                        )
                },
                {
                    title: "Name",
                    keyPath: "",
                    updateCell: (cellView: CellView, dataItem: ({ user: RHUserProfile } & { company: RHCompany })) =>
                        cellView.titleLabel.text = IF((dataItem as any).company)(() =>
                            (dataItem as { company: RHCompany }).company.name
                        ).ELSE(() =>
                            (dataItem as { user: RHUserProfile }).user?.email ?? (dataItem as any as RHUserProfile).email
                        )
                },
                {
                    title: "Identifier",
                    keyPath: "",
                    updateCell: (cellView: CellView, dataItem: ({ user: RHUserProfile } & { company: RHCompany })) =>
                        cellView.titleLabel.text = IF((dataItem as any).company)(() =>
                            "Reg: " + (dataItem as { company: RHCompany }).company.businessRegistryCode
                        )
                            .ELSE(() =>
                                (dataItem as { user: RHUserProfile }).user?.email ?? (dataItem as any as RHUserProfile).email
                            )
                    
                },
                {
                    title: "Id",
                    keyPath: "_id"
                }
            
            
            ]
        }).addedAsSubviewToView(this.view)
    bottomView = new UIView().addedAsSubviewToView(this.view)
    
    
    constructor(view: UIView) {
        
        super(view)
        
        // Code for further setup if necessary
        
        this.view.configureWithObject({
            backgroundColor: UIColor.whiteColor,
            hoverText: ""
        })
        
    }
    
    
    static override readonly routeComponentName = "sysadmin"
    
    static override readonly ParameterIdentifierName = {}
    
    
    override async handleRoute(route: UIRoute) {
        
        super.handleRoute(route)
        const inquiryComponent = route.componentWithName(AdministrationViewController.routeComponentName)
        
        const requestResult = await SocketClient.RetrieveListOfUsersAndCompanies()
        
        if (requestResult.errorResult) {
            console.log(requestResult.errorResult)
            route.routeByRemovingComponentNamed(AdministrationViewController.routeComponentName).apply()
            return
        }
        
        const data = requestResult.result
        console.log(data)
        
        
        this.dataView.setTreeData(
            data.companies.map(company => {
                    return { company: company }
                }
            ).concat(
                data.unemployedUsers.map(user => {
                        return { user: user }
                    }
                ) as any
            ) as any,
            // @ts-ignore
            "company.companyEmployees"
        )
        
        
    }
    
    
    override layoutViewSubviews() {
        
        super.layoutViewSubviews()
        
        const padding = this.core.paddingLength
        const labelHeight = padding * 2
        
        // View bounds
        const bounds = this.view.bounds.rectangleWithInset(padding)
        
        this.titleLabel.frame = bounds.rectangleWithHeight(labelHeight * 2)
        
        this.titleLabel.frame
            .rectangleForNextRow(padding * 0.25)
            .distributeViewsEquallyAlongWidth([this.explanationView], padding)
            .rectangleForNextRow(padding, 700)
            .distributeViewsEquallyAlongWidth([this.dataView], padding)
            .rectangleForNextRow(padding, 1)
            .distributeViewsEquallyAlongWidth([this.bottomView], padding - 1)
        
    }
}
